import React from "react";
import { TableColumn } from "../../../../components/table/Table";
import { AllDestinations } from "../../../../models/destination";
import {
  DestinationActionsColumn,
  DestinationCreatedColumn,
  DestinationNameColumn,
  DestinationTemplatesColumn,
  DestinationURLColumn,
} from "./components";

export const destinationColumns: TableColumn<AllDestinations>[] = [
  {
    key: "name",
    title: "Name",
    headerClassName: "text-left w-[35%]",
    render: (destination) => (
      <DestinationNameColumn destination={destination} />
    ),
  },
  {
    key: "url",
    title: "URL",
    headerClassName: "text-left w-[35%]",
    render: (destination) => <DestinationURLColumn destination={destination} />,
  },
  {
    key: "status",
    title: "Status",
    headerClassName: "text-left w-[35%]",
    render: (destination) => <div>{destination?.destination?.status}</div>,
  },
  {
    key: "createdAt",
    title: "Created",
    headerClassName: "text-left w-[15%]",
    render: (destination) => (
      <DestinationCreatedColumn destination={destination} />
    ),
  },
  {
    key: "templateList",
    title: "Templates",
    headerClassName: "md:text-left w-[5%]",
    render: (destination) => (
      <DestinationTemplatesColumn destination={destination} />
    ),
  },
  {
    key: "destinationId",
    title: "",
    cellClassName: "md:float-right",
    headerClassName: "w-[10%]",
    render: (destination) => (
      <DestinationActionsColumn destination={destination} />
    ),
  },
];
